<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 flex flex-col bg-white dark:bg-gray-900 overflow-y-auto"
    style="z-index: 60;"
  >
    <div class="flex justify-between items-center p-5">
      <NuxtLink :to="`/${locale}`" @click="close">
        <Logo class="w-[120px] md:w-[180px]" :color="getLogoColor" :alt="`${runtimeConfig.public.siteName} Logo`"/>
      </NuxtLink>
      <button
        @click="close"
        class="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
        aria-label="Cerrar menú"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <div class="flex-1 p-5">
      <ul class="space-y-4">
        <li v-for="publicationType in PublicationTypeValues.getList()" :key="publicationType.value">
          <NuxtLink
            :to="{
              name: `type-tickets-dateId___${locale}`,
              params: {
                type: publicationType.value
              }
            }"
            @click="close"
            class="flex justify-between items-center p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <span class="text-lg font-medium">{{ publicationType.label_plural }}</span>
            <i class="mdi mdi-chevron-right text-2xl text-gray-400"></i>
          </NuxtLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import PublicationTypeValues from '~/values/PublicationTypeValues.js'

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close'])
const { locale } = useI18n()
const runtimeConfig = useRuntimeConfig()
const colorMode = useColorMode()

onMounted(() => {
  window.addEventListener('popstate', handleBackButton)
})

onBeforeUnmount(() => {
  window.removeEventListener('popstate', handleBackButton)
})

const getLogoColor = computed(() => {
  if (colorMode.value === 'light') {
    return mainStore.isHeaderTransparent ? 'light' : 'dark'
  }

  return 'auto'
})

function handleBackButton(event) {
  if (props.isOpen) {
    event.preventDefault()
    close()
    history.pushState(null, document.title, window.location.href)
  }
}

function close() {
  emit('close')
}
</script>

<style scoped>
.mdi-chevron-left {
  transition: transform 0.2s ease;
}

a:hover .mdi-chevron-left {
  transform: translateX(-4px);
}
</style>
